"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _groupHisaiRegisterActions = require("../register/groupHisaiRegisterActions");
var _groupHisaiSearchActions = require("../search/groupHisaiSearchActions");
var _groupHisaiSortActions = require("../sort/groupHisaiSortActions");
const grouphisaiReducers = {
  groupHisaiSearch: _groupHisaiSearchActions.groupHisaiSearchReducer,
  groupHisaiRegister: _groupHisaiRegisterActions.groupHisaiRegisterReducer,
  groupHisaiSort: _groupHisaiSortActions.groupHisaiSortReducer
};
var _default = exports.default = grouphisaiReducers;